<div class="card">
	<div class="card-header">
		<h1>Administrativa</h1>
	</div>
	<div class="row">
		<div class="col-sm-6 form-group" *ngIf="showPartnerFilter">
			<label for="partner" class="form-label">Partner</label>
			<div class="input-group">
				<app-input-autocomplete id="input-partner" (changeStatus)="selectPartner($event.filterElement)"
					(inputMethod)="searchPartner()" [allBorderRadius]="true" [filterElements]="partners"
					[placeholder]="'Busca un partner'" [custom]="true" [inputs]="inputPartner">
					<ng-template #itemsTemplate let-filter>
						<div items>
							<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
								{{filter.name}}</h5>
							<span class="text-muted" style="color: white !important;">
								{{filter.email}}
							</span>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
		<div class="col-sm-6 form-group">
			<label for="company" class="form-label">Empresa:</label>
			<div class="input-group">
				<app-input-autocomplete id="input-company" (changeStatus)="selectCompany($event.filterElement)"
					(inputMethod)="searchCompany()" [allBorderRadius]="true" [filterElements]="companies"
					[placeholder]="'Busca una empresa'" [custom]="true" [inputs]="inputCompany">
					<ng-template #itemsTemplate let-filter>
						<!-- This is the content that will be projected -->
						<div items>
							<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
								{{filter.companyName?filter.companyName:filter.name}}</h5>
							<span class="text-muted" style="color: white !important;">{{filter.alphanumericId}} -
								NIT: <b>{{filter.companyNIT?filter.companyNIT:filter.nit}}</b></span>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
		<div class="col-sm-6 form-group">
			<label for="year" class="form-label">Año:</label>
			<select id="year" class="form-select" [(ngModel)]="selectedYear">
				<option *ngFor="let year of years" [value]="year">{{year}}</option>
			</select>
		</div>
		<div class="col-sm-6 form-group">
			<label for="month" class="form-label">Mes:</label>
			<select id="month" class="form-select" [(ngModel)]="selectedMonth">
				<option *ngFor="let month of months" [value]="month.value">{{month.name}}</option>
			</select>
		</div>
		<app-loading-button style="width: 100%;" [logo]="true" colorLoading="white" [object]="buttonSave"
			(clicked)="filter()"></app-loading-button>
		<app-loading-button *ngIf="selectedPartner && companies.length > 0" [logo]="true" colorLoading="white"
			[object]="buttonBlockPartner" (clicked)="blockPartner()"></app-loading-button>
	</div>
	<div class="card-body">
		<div class="table-responsive mt-1" style="margin: 0; max-height: 70vh;">
			<table class="table table-striped" style="margin: 0;">
				<thead class="sticky-thead">
					<tr class="tr-middle">
						<th class="sticky-col first-col">
							Partner
						</th>
						<th>
							<i *ngIf="minimized['daysWithoutXmlE']" title="Expandir Días sin XMLE"
								(click)="minimize('daysWithoutXmlE', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['daysWithoutXmlE']">
								Dias sin XMLE
								<br>
								<i class="fa" (click)="sort('daysWithoutXmlE')" [ngClass]="
									{'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn !== 'daysWithoutXmlE', 
									'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'daysWithoutXmlE', 
									'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'daysWithoutXmlE'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('daysWithoutXmlE')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['daysWithoutXmlR']" title="Expandir Días sin XMLR"
								(click)="minimize('daysWithoutXmlR', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['daysWithoutXmlR']">
								Dias sin XMLR
								<br>
								<i class="fa" (click)="sort('daysWithoutXmlR')" [ngClass]="{
									'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn !== 'daysWithoutXmlR',
									'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'daysWithoutXmlR', 
									'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'daysWithoutXmlR'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('daysWithoutXmlR')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['daysWithoutBank']" title="Expandir Días sin Banco"
								(click)="minimize('daysWithoutBank', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['daysWithoutBank']">
								Dias sin Banco
								<br>
								<i class="fa" (click)="sort('daysWithoutBank')" [ngClass]="{
									'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn !== 'daysWithoutBank',
									'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'daysWithoutBank',
									'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'daysWithoutBank'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('daysWithoutBank')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['usersCount']" title="Expandir Usuarios"
								(click)="minimize('usersCount', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['usersCount']">
								Usuarios
								<br>
								<i class="fa" (click)="sort('usersCount')" [ngClass]="
								{'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn != 'usersCount',
								'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'usersCount', 
								'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'usersCount'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('usersCount')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['balanceDTE']" title="Expandir Saldo DTE"
								(click)="minimize('balanceDTE', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['balanceDTE']">
								Saldo DTE
								<br>
								<i class="fa" (click)="sort('balanceDTE')" [ngClass]="
								{'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn != 'balanceDTE', 
								'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'balanceDTE', 
								'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'balanceDTE'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('balanceDTE')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['xmlECount']" title="Expandir XMLE"
								(click)="minimize('xmlECount', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['xmlECount']">
								XMLE
								<br>
								<i class="fa" (click)="sort('xmlECount')" [ngClass]="
								{'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn != 'xmlECount',
								'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'xmlECount',
								'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'xmlECount'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('xmlECount')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['xmlRCount']" title="Expandir XMLR"
								(click)="minimize('xmlRCount', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['xmlRCount']">
								XMLR
								<br>
								<i class="fa" (click)="sort('xmlRCount')" [ngClass]="
								{'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn != 'xmlRCount', 
								'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'xmlRCount', 
								'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'xmlRCount'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('xmlRCount')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['banksCount']" title="Expandir Bancos"
								(click)="minimize('banksCount', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['banksCount']">
								Bancos
								<br>
								<i class="fa" (click)="sort('banksCount')" [ngClass]="
								{'fa-arrow-right-arrow-left': sortColumn === '' || sortColumn != 'banksCount', 
								'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'banksCount', 
								'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'banksCount'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('banksCount')"></i>
							</ng-container>
						</th>
						<th>
							<i *ngIf="minimized['libraryCount']" title="Expandir Biblioteca"
								(click)="minimize('libraryCount', false)" class="fa fa-maximize clickeable"></i>
							<ng-container *ngIf="!minimized['libraryCount']">
								Biblioteca
								<br>
								<i class="fa" (click)="sort('libraryCount')" [ngClass]="
								{'fa-arrow-right-arrow-left': (sortColumn === '' || sortColumn != 'libraryCount'), 
								'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'libraryCount', 
								'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'libraryCount'}"></i>
								<i title="Minimizar" class="fa fa-minimize clickeable" (click)="minimize('libraryCount')"></i>
							</ng-container>
						</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngIf="!buttonSave.loading || pagination.filter.length > 0">
						<tr *ngFor="let companyId of pagination.filter" class="tr-middle">
							<td class="sticky-col first-col" style="min-width: 200px;">
								<div class="row">
									<div class="col">
										<p class="titles">{{ companyId }}</p>
										<p class="fields">Código</p>
									</div>
									<div class="col">
										<p class="titles">{{ getBalanceById(companyId, 'nitCompany') }}</p>
										<p class="fields">NIT</p>
									</div>
								</div>
								<p class="titles" [tooltip]="getBalanceById(companyId, 'nameCompany')">{{
									cropName(getBalanceById(companyId, 'nameCompany')) }}</p>
								<p class="fields">Nombre</p>
							</td>
							<td class="info-hover">
								<ng-container *ngIf="!minimized['daysWithoutXmlE']">
									{{ getBalanceById(companyId, 'daysWithoutXmlE') === -1 ? 'No se ha usado' :
									(getBalanceById(companyId, 'daysWithoutXmlE') | number:'1.0-0') }}
									<ng-container *ngIf="getBalanceById(companyId, 'daysWithoutXmlE') !== -1">
										<i class="fa fa-eye clickeable eye-info"
											(click)="getDisplayWarehouseDaysWithoutXmlE(companyId)"></i>
									</ng-container>
								</ng-container>
							</td>
							<td class="info-hover">
								<ng-container *ngIf="!minimized['daysWithoutXmlR']">
									{{ getBalanceById(companyId, 'daysWithoutXmlR') === -1 ? 'No se ha usado' :
									(getBalanceById(companyId, 'daysWithoutXmlR') | number:'1.0-0') }}
									<ng-container *ngIf="getBalanceById(companyId, 'daysWithoutXmlR') !== -1">
										<i class="fa fa-eye clickeable eye-info"
											(click)="getDisplayWarehouseDaysWithoutXmlR(companyId)"></i>
									</ng-container>
								</ng-container>
							</td>
							<td>
								<ng-container *ngIf="!minimized['daysWithoutBank']">
									{{ getBalanceById(companyId, 'daysWithoutBank') === -1 ? 'No se ha usado' :
								(getBalanceById(companyId, 'daysWithoutBank') | number:'1.0-0') }}
								</ng-container>
							</td>
							<td class="info-hover">
								<ng-container *ngIf="!minimized['usersCount']">
									{{ getBalanceById(companyId, 'usersCount') | number:'1.0-0' }}
									<ng-container *ngIf="getBalanceById(companyId, 'usersCount') !== -1">
										<i class="fa fa-eye clickeable eye-info"
											(click)="getUsersAdministrative(companyId)"></i>
									</ng-container>
								</ng-container>
							</td>
							<td>
								<ng-container *ngIf="!minimized['balanceDTE']">
									{{ getBalanceById(companyId, 'balanceDTE') | number:'1.0-0' }}
								</ng-container>
							</td>
							<td>
								<ng-container *ngIf="!minimized['xmlECount']">
									{{ getBalanceById(companyId, 'xmlECount') | number:'1.0-0' }}
								</ng-container>
							</td>
							<td>
								<ng-container *ngIf="!minimized['xmlRCount']">
									{{ getBalanceById(companyId, 'xmlRCount') | number:'1.0-0' }}
								</ng-container>
							</td>
							<td>
								<ng-container *ngIf="!minimized['banksCount']">
									{{ getBalanceById(companyId, 'banksCount') | number:'1.0-0' }}
								</ng-container>
							</td>
							<td>
								<ng-container *ngIf="!minimized['libraryCount']">
									{{ getBalanceById(companyId, 'libraryCount') | number:'1.0-0' }}
								</ng-container>
							</td>
							<td>
								<button *ngIf="getBalanceById(companyId, 'isActive')" tooltip="Bloquear" placement="left"
									(click)="blockCompanyButton(companyId)" class="btn btn-danger">
									<i class="fa fa-lock"></i>
								</button>
								<button *ngIf="!getBalanceById(companyId, 'isActive')" tooltip="Desbloquear" placement="left"
									(click)="unBlockCompanyButton(companyId)"
									class="btn btn-success">
									<i class="fa fa-lock-open"></i></button>
							</td>
						</tr>
					</ng-container>
					<tr *ngIf="pagination.filter.length == 0" class="tr-middle">
						<td colspan="11">
							<span class="display-5" style="opacity: 0.6; display: flex;">
								<ng-container *ngIf="buttonSave.loading">
									<app-loading-animation [height]="'3rem'"
										*ngIf="buttonSave.loading"></app-loading-animation>
									Cargando...
								</ng-container>
								<ng-container *ngIf="!buttonSave.loading">
									<i class="fa fa-circle-info"></i>
									{{sought?'No se encontraron resultados':'Presiona el botón de buscar'}}
								</ng-container>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<app-pagination-custom [elements]="pagination"></app-pagination-custom>
	</div>
</div>
<app-modal-warehouse-days-xml *ngIf="daysWarehouseXML" (close)="daysWarehouseXML = null"
	[xml]="daysWarehouseXML?.elements" [isXMLE]="daysWarehouseXML?.isXMLE"
	[companyName]="daysWarehouseXML?.name"></app-modal-warehouse-days-xml>
<app-modal-user-administrative *ngIf="usersAdministrative" [companyName]="usersAdministrative?.name"
	(close)="usersAdministrative = null" [users]="usersAdministrative?.elements"></app-modal-user-administrative>